import React from "react";
import Wrapper from "../../../components/templates/Wrapper";
import Link from "../../../components/atoms/Link";
import Label from "../../../components/atoms/Label";

const ResetFailed = (props) => {
  return (
    <Wrapper
      direction="column"
      margin="2.5rem 0"
      align="center"
      justify="center"
    >
      <Label fontSize="1rem" align="center" color="var(--color-6)">
        The password reset link has expired.
        <Link
          fontSize="1rem"
          color="var(--color-5)"
          margin="1rem 0 1rem .5rem"
          to="/forgot-password"
        >
          Please try again.
        </Link>
      </Label>
    </Wrapper>
  );
};

export default ResetFailed;